import React from "react";
import { GroupClientRow } from "../Modals/GroupClients";
import { withStyles, makeStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TablePagination from "@material-ui/core/TablePagination";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { Button } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import GroupClients from "../Modals/GroupClients";
import UserGroupCard from "./UserGroupCard";
import dayjs from "dayjs";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#fd9b15",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  table: {
    minWidth: 700,
  },
});

interface GroupRow {
  description?: string;
  email?: React.ReactNode;
  member_details?: unknown[];
  members?: unknown[];
  name?: string;
  start_date?: string;
}

interface UserGroupsProps {
  groups: GroupRow[];
}

export default function CustomizedTables(props: UserGroupsProps): React.ReactElement {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [open, setOpen] = React.useState(false);
  const [clients, setClients] = React.useState<GroupClientRow[]>([]);
  const [page, setPage] = React.useState(0);
  const [groupName, setGroupName] = React.useState<string>("");
  const [rowsPerPage, setRowsPerPage] = React.useState(7);
  const rows = props.groups.reverse();

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  return isMobile ? (
    <div>
      {rows
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map((row) => (
          <UserGroupCard
            key={row.name as React.Key}
            group={row}
            onView={() => {
              setClients(row.member_details as GroupClientRow[]);
              setGroupName(row.name!);
              setOpen(true);
            }}
          />
        ))}
      <TablePagination
        rowsPerPageOptions={[5, 7, 14, 50]}
        style={{ marginTop: 16, background: "#fafafa", borderRadius: 4 }}
        component='div'
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <GroupClients
        groupName={groupName}
        clients={clients}
        open={open}
        setOpen={setOpen}
      />
    </div>
  ) : (
    <div>
      <Paper className={(classes as { root?: string }).root} variant='outlined'>
        <TableContainer style={{ maxHeight: 440 }}>
          <Table className={classes.table} aria-label='customized table'>
            <TableHead>
              <TableRow>
                <StyledTableCell style={{}}>Group Name</StyledTableCell>
                <StyledTableCell>Description</StyledTableCell>
                <StyledTableCell align='center' style={{}}>
                  Members
                </StyledTableCell>
                <StyledTableCell align='center' style={{}}>
                  Creation Date
                </StyledTableCell>
                <StyledTableCell align='center' style={{}}>
                  Details
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => (
                  <StyledTableRow key={row.email as React.Key}>
                    <StyledTableCell
                      component='th'
                      scope='row'
                      style={{
                        borderRight: "1px solid #e3e3e3",
                        paddingTop: 10,
                        paddingBottom: 10,
                      }}
                    >
                      {row.name}
                    </StyledTableCell>
                    <StyledTableCell
                      style={{
                        borderRight: "1px solid #e3e3e3",
                        paddingTop: 10,
                        paddingBottom: 10,
                      }}
                    >
                      {row.description?.length
                        ? row.description
                        : "Not Specified"}
                    </StyledTableCell>
                    <StyledTableCell
                      align='center'
                      style={{
                        borderRight: "1px solid #e3e3e3",
                        paddingTop: 10,
                        paddingBottom: 10,
                      }}
                    >
                      {row.members!.length}
                    </StyledTableCell>
                    <StyledTableCell
                      align='center'
                      style={{
                        borderRight: "1px solid #e3e3e3",
                        paddingTop: 10,
                        paddingBottom: 10,
                      }}
                    >
                      {dayjs(row.start_date).format("DD/MM/YYYY")}
                    </StyledTableCell>
                    <StyledTableCell
                      align='center'
                      style={{
                        borderRight: "1px solid #e3e3e3",
                        paddingTop: 10,
                        paddingBottom: 10,
                      }}
                    >
                      {" "}
                      <Button
                        variant='outlined'
                        size='small'
                        disabled={row.members!.length ? false : true}
                        onClick={() => {
                          setClients(row.member_details as GroupClientRow[]);
                          setGroupName(row.name!);
                          setOpen(true);
                        }}
                      >
                        View
                      </Button>
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 7, 14, 50]}
          style={{ borderTop: "1px solid #e3e3e3", background: "#fafafa" }}
          component='div'
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />{" "}
      </Paper>
      <GroupClients
        groupName={groupName}
        clients={clients}
        open={open}
        setOpen={setOpen}
      />
    </div>
  );
}
